import url from './apiUrl'
import handleResponse from './handleResponse'


export default (data) => {
    return fetch(`${url()}/users/login`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                body: JSON.stringify(data)
            })
            .then(res => handleResponse(res))
}